// extracted by mini-css-extract-plugin
export var actionButton = "_cc-0";
export var attachmentLine = "_cc-1";
export var fileInput = "_cc-2";
export var fileUploadWrapper = "_cc-4";
export var footer = "_cc-3";
export var modalContent = "_cc-5";
export var paperclip = "_cc-6";
export var quillEditor = "_cc-7";